import React, { useEffect, useState } from 'react'
import ToggleSwitch from '../../ReusableComponents/ToggleSwitch/ToggleSwitch'
import { trackingState } from './detectors/trackingDetector'
import styles from './Vision.module.css'

// Sidebar options for Object Tracking (target class, line crossing, trajectory)
// — the panel that lives beside the detection selector, like the mobile layout.
const TrackingOptions = () => {
    const [target, setTarget] = useState(trackingState.target)
    const [lineCrossing, setLineCrossing] = useState(trackingState.lineCrossing)
    const [trajectory, setTrajectory] = useState(trackingState.trajectory)
    const [trajectoryId, setTrajectoryId] = useState(
        trackingState.trajectoryId == null
            ? ''
            : String(trackingState.trajectoryId)
    )
    const [, force] = useState(0)
    // Refresh the class list + live tracked ids as detections update.
    const [classes, setClasses] = useState(trackingState.classesSeen)
    const [ids, setIds] = useState(trackingState.trackedIds)
    useEffect(() => {
        const t = setInterval(() => {
            setClasses(trackingState.classesSeen.slice())
            setIds(trackingState.trackedIds.slice())
        }, 500)
        return () => clearInterval(t)
    }, [])

    const onTarget = (e) => {
        setTarget(e.target.value)
        trackingState.target = e.target.value
    }
    const onLine = (n) => {
        setLineCrossing(n)
        trackingState.lineCrossing = n
    }
    const onTraj = (n) => {
        setTrajectory(n)
        trackingState.trajectory = n
    }
    const onTrajId = (e) => {
        const v = e.target.value
        setTrajectoryId(v)
        trackingState.trajectoryId = v === '' ? null : v
        trackingState._traj = []
    }

    const options = ['all', ...classes]

    return (
        <div className={styles.trackOptions}>
            <div className={styles.trackOptRow}>
                <span className={styles.trackOptLabel}>Object</span>
                <select
                    className={styles.trackOptSelect}
                    value={target}
                    onChange={onTarget}
                >
                    {options.map((c) => (
                        <option key={c} value={c}>
                            {c === 'all' ? 'All Objects' : c}
                        </option>
                    ))}
                </select>
            </div>
            <div className={styles.trackOptToggleRow}>
                <span className={styles.trackOptLabel}>Line Crossing</span>
                <ToggleSwitch
                    size="md"
                    tone="blue"
                    checked={lineCrossing}
                    onChange={onLine}
                    ariaLabel="Toggle line crossing"
                />
            </div>
            {lineCrossing && (
                <div className={styles.trackLineEdit}>
                    <span className={styles.trackLineHint}>
                        Draw the route in order, then double-click to finish. An
                        object is “passed” only when it travels through every
                        point from start to end.
                    </span>
                    <div className={styles.trackLineBtns}>
                        <button
                            className={styles.trackLineBtn}
                            onClick={() => {
                                trackingState.pathPoints =
                                    trackingState.pathPoints.slice(0, -1)
                                trackingState.pathDone = false
                                force((n) => n + 1)
                            }}
                        >
                            Undo Point
                        </button>
                        <button
                            className={styles.trackLineBtn}
                            onClick={() => {
                                trackingState.pathPoints = []
                                trackingState.pathDone = false
                                force((n) => n + 1)
                            }}
                        >
                            Clear
                        </button>
                    </div>
                </div>
            )}
            <div className={styles.trackOptToggleRow}>
                <span className={styles.trackOptLabel}>Trajectory</span>
                <ToggleSwitch
                    size="md"
                    tone="blue"
                    checked={trajectory}
                    onChange={onTraj}
                    ariaLabel="Toggle trajectory"
                />
            </div>
            {trajectory && (
                <div className={styles.trackOptRow}>
                    <span className={styles.trackOptLabel}>Track ID</span>
                    <select
                        className={styles.trackOptSelect}
                        value={trajectoryId}
                        onChange={onTrajId}
                    >
                        <option value="">Auto (largest)</option>
                        {ids.map((o) => (
                            <option key={o.id} value={o.id}>
                                #{o.id} {o.class}
                            </option>
                        ))}
                    </select>
                </div>
            )}
        </div>
    )
}

export default TrackingOptions
